import Vue from 'vue'
import App from './App'
import store from '@/store'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import HmacUtils from './tools/hmac-utils.js'
Vue.prototype.$HmacUtils = HmacUtils; //python接口方法

import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css';

//公共样式
import '@/assets/css/common.css'
import types from '@/constants/types'
import './tools/dialogDrag' //自定义指令
import socket from '@/tools/socket.js'
import decoder from '@/tools/decode.js'
import broadcast from '@/tools/broadcast.js'
import timescheck from '@/tools/timescheck.js'

//导入Echarts
import echarts from "echarts";
Vue.prototype.$echarts = echarts;

// token解析
var jwt = require('jsonwebtoken');
Vue.prototype.$jwt = jwt; //jwt

import Blob from './vendor/Blob'
import Export2Excel from './vendor/Export2Excel.js'

// 导入拖动弹窗组件
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
Vue.component('vue-draggable-resizable', VueDraggableResizable)


Vue.config.productionTip = false;

Vue.use(ElementUI);

Vue.prototype.$types = types; //vuex action类型
Vue.prototype.$decoder = decoder //解压缩方法
Vue.prototype.$socket = socket; //socket 对象封装
Vue.prototype.$layer = layer(Vue); //vue 弹窗工具
Vue.prototype.$broadcast = broadcast; //注册全局广播
Vue.prototype.$timescheck = timescheck; //注册全局时间检测

new Vue({
    el: '#app',
    store,
    router,
    components: {
        App
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js